import gql from "graphql-tag";

export const MY_HR_REGISTER_2FA_EMAIL = gql`
  mutation register2faEmail($email: String!) {
    register2faEmail(email: $email) {
      status
      secret
    }
  }
`;
